import { getCookie } from 'cookies-next';


const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

export const getRecommended = async (slug, email, localeValue = 'en') => {
    // let localeValue = getCookie('NEXT_LOCALE')
    let currencyValue = getCookie('currency')

    const url = `${baseUrl}/properties/recommended/${slug}`
    const headers = {
        'apikey': process.env.NEXT_PUBLIC_RSTBASE_API_KEY,
        'currency': currencyValue || 'thb',
        'locale': localeValue || 'en'
    }

    const response = await fetch(url, {
        headers: headers,
        cache: 'no-store'
        // next: { revalidate: 900 } // 15m

    })

    const result = await response.json()
    // console.log(result.properties)
    return result

}